export namespace AuthActions {
  export class Signup {
    static readonly type = '[Auth] Signup';
    constructor(public payload: { email: string; password: string; inviteCode: string }) { }
  }

  export class Login {
    static readonly type = '[Auth] Login';
    constructor(public payload: { email: string; password: string }) { }
  }

  export class RefreshToken {
    static readonly type = '[Auth] Refresh Token';
    constructor(public payload: { refreshToken: string }) { }
  }

  export class LoginWWU {
    static readonly type = '[Auth] Login Work With Us';
    constructor(public payload: { email: string; password: string }) { }
  }


  export class ContinueWithEmail {
    static readonly type = '[Auth] Continue With Email';
    constructor(public payload: { email: string }) { }
  }

  export class ChangePassword {
    static readonly type = '[Auth] Change Password';
    constructor(public payload: { authId: string; currentPassword: string; newPassword: string }) { }
  }

  export class PasskeyAuthenticationOptions {
    static readonly type = '[Auth] Passkey Authentication Options';
    constructor(public payload: { email: string }) { }
  }

  export class PasskeyLogin {
    static readonly type = '[Auth] Passkey Login';
    constructor(public payload: {
      email: string;
      response: {};
      deviceId: string;
      rememberMe: boolean
    }) { }
  }

  export class PasskeyRegistrationOptions {
    static readonly type = '[Auth] Passkey Registration Options';
    constructor(public payload: {
      authId: string,
      deviceName: string
    }) { }
  }

  export class PasskeyRegistrationVerify {
    static readonly type = '[Auth] Passkey Registration Verify';
    constructor(public payload: { authId: string; response: {}; deviceName: string }) { }
  }

  

  export class Logout {
    static readonly type = '[Auth] Logout';
  }

  export class SetReferralJobSlug {
    static readonly type = '[Auth] Set Referral Job Slug';
    constructor(public payload: string) { }
  }

  export class CreateAccountWorkWithUs {
    static readonly type = '[Auth] Create Account Work With Us';
    constructor(public payload: {
      firstName: string;
      lastName: string;
      email: string;
      office: string;
      role: string;
      gender: string;
      dateOfBirth: string;
      password: string
    }) { }
  }

  export class SendForgotPasswordRequest {
    static readonly type = '[Auth] Send Forgot Password Request';
    constructor(public payload: { email: string, redirectUrl: string }) { }
  }

  export class VerifyForgotPasswordRequest {
    static readonly type = '[Auth] Verify Forgot Password Request';
    constructor(public payload: { authId: string; resetToken: string; password: string }) { }
  }

  export class ResendVerificationEmail {
    static readonly type = '[Auth] Resend Verification Email';
    constructor(public payload: { email: string }) { }
  }

  export class GenerateOtp {
    static readonly type = '[Auth] Generate OTP';
    constructor(public payload: { email: string; authId: string }) { }
  }

  export class GenerateOtpWWU {
    static readonly type = '[Auth] Generate OTP WWU';
    constructor(public payload: { email: string; authId: string }) { }
  }

  export class VerifyOtp {
    static readonly type = '[Auth] Verify OTP';
    constructor(public payload: { email: string; token: string }) { }
  }

  export class VerifyOtpWWU {
    static readonly type = '[Auth] Verify OTP WWU';
    constructor(public payload: { email: string; token: string }) { }
  }

  export class VerifyEmail {
    static readonly type = '[Auth] Verify Email';
    constructor(public payload: { email: string; password: string, code: string }) { }
  }

  export class VerifyEmailWWU {
    static readonly type = '[Auth] Verify Email WWU';
    constructor(public payload: { email: string; password: string, code: string }) { }
  }

  export class ValidateOtp {
    static readonly type = '[Auth] Validate OTP';
    constructor(public payload: { email: string; token: string }) { }
  }


  export class ValidateOtpWWU {
    static readonly type = '[Auth] Validate OTP WWU';
    constructor(public payload: { email: string; token: string }) { }
  }

  export class EnableEmail2FAWWU {
    static readonly type = '[Auth] Enable Email 2FA WWU';
    constructor(public id: string) { }
  }

  export class DisableOtp {
    static readonly type = '[Auth] Disable OTP';
    constructor(public payload: { email: string; authId: string }) { }
  }

  export class GetMe {
    static readonly type = '[Auth] Get Me';
  }

  export class EnableEmail2FA {
    static readonly type = '[Auth] Enable Email 2FA';
    constructor(public id: string) { }
  }

  export class ConfirmEmail2FA {
    static readonly type = '[Auth] Confirm Email 2FA';
    constructor(public otp: string) { }
  }

  export class ConfirmEmail2FAWWU {
    static readonly type = '[Auth] Confirm Email 2FA WWU';
    constructor(public otp: string) { }
  }

  export class SkipOTPCheck {
    static readonly type = '[Auth] SKIP OTP CHECK';
  }

  // Passkey Setup Actions
  export class StartPasskeySetup {
    static readonly type = '[Auth] Start Passkey Setup';
    constructor(public passkeyName: string) { }
  }

  export class CompletePasskeyRegistration {
    static readonly type = '[Auth] Complete Passkey Registration';
    constructor(public payload: {
      passkeyName: string;
      credential: any;
      registrationOptions: any;
    }) { }
  }

  export class LoadUserPasskeys {
    static readonly type = '[Auth] Load User Passkeys';
  }

  export class DeletePasskey {
    static readonly type = '[Auth] Delete Passkey';
    constructor(public passkeyId: string) { }
  }

}
